export default __webpack_public_path__ + "static/embajadores_cuadrada-ec966b912d4ea35f6147700adb2ad46a.jpg";